import { ImpressionsList } from '../types/types';

export interface PreviewImages {
    nextUrl: string;
    prevUrl: string;
    currentIndex: number;
}

/**
 * Utility functions for slider preview image calculations
 */
export class SliderUtils {
    /**
     * Calculate preview image URLs and current index
     * @param currentIndex - Current slide index
     * @param impressionsList - List of impressions
     * @returns Object with preview URLs and current index
     */
    static calculatePreviewImages(currentIndex: number, impressionsList: ImpressionsList | undefined): PreviewImages {
        if (!impressionsList || !impressionsList.items || impressionsList.items.length === 0) {
            return {
                nextUrl: '',
                prevUrl: '',
                currentIndex: 0,
            };
        }

        const listItems = impressionsList.items;
        const listLength = listItems.length;

        const nextIndex = (currentIndex + 1) % listLength;
        const prevIndex = (currentIndex - 1 + listLength) % listLength;

        return {
            nextUrl: listItems[nextIndex].img,
            prevUrl: listItems[prevIndex].img,
            currentIndex: currentIndex,
        };
    }
}
